module.exports = __webpack_public_path__ + "static/img/1.0b029ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/zh/1.png
// module id = RM3l
// module chunks = 0